import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { usePortal } from '../../contexts/PortalContext';

// Guard for /portal/* pages. Routing mirrors the SERVER's surface limits (the
// API enforces them regardless): no session -> login; non-active payees are
// pinned to the status screen; active partners never see the status screen.
const PortalRoute = ({ as: Component }) => {
  const { portalToken, portalUser } = usePortal();
  const location = useLocation();

  if (!portalToken) return <Navigate to="/portal/login" replace />;

  const isStatusPage = location.pathname === '/portal/status';
  const active = portalUser?.status === 'active';
  if (!active && !isStatusPage) return <Navigate to="/portal/status" replace />;
  if (active && isStatusPage) return <Navigate to="/portal" replace />;

  return <Component />;
};

export default PortalRoute;
